import React from 'react';
import { Title, Box, Button, Flex, Text } from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { formatPrice } from '@/utils/utilities';
import { creatorActions } from '@/store/slices/creatorSlice';
import { Collections } from './steps/Collections';
import { useUpdateProject } from '@/hooks/useUpdateProject';
import styles from './Aside.module.scss';
import { IconArrowNarrowRight, IconShoppingBag } from '@tabler/icons-react';

export const Aside: React.FC = () => {
	const dispatch = useTypedDispatch();

	useUpdateProject();

	const { options, project, selectedProductModuleCollection } =
		useTypedSelector((state) => state.creator);

	const handleOpenSummary = () => {
		dispatch(creatorActions.updateOptions({ summaryDrawerOpened: true }));
	};

	const handleOpenDownloadModel = () => {
		dispatch(creatorActions.updateOptions({ downloadDrawerOpened: true }));
	};

	return (
		<Box
			component="aside"
			className={styles.container}
			id="creator-aside"
			px={{ base: 'md', md: 'lg' }}
		>
			<Box pos="relative" h="100%">
				<Collections />
				{!!selectedProductModuleCollection && (
					<Box className={styles.stickyBottom}>
						<Flex justify="space-between" mb="lg" mt="sm">
							<Text>Cena brutto</Text>
							<Title order={3}>
								{formatPrice(project ? project.price / 100 : 0, {
									currencyDisplay: 'symbol',
								})}
							</Title>
						</Flex>
						{/* <Flex justify="space-between" mb="sm">
						<Anchor underline="always" onClick={handleOpenSummary}>
							Zobacz podsumowanie
						</Anchor>
						<Anchor underline="always" onClick={handleOpenDownloadModel}>
							Pobierz konfigurację
						</Anchor>
					</Flex> */}

						{!options.isPresetMode && (
							<Button size="lg" color="black" type="submit" fullWidth mb="md">
								<Flex gap="sm">
									Do koszyka
									<IconShoppingBag />
								</Flex>
							</Button>
						)}
						<Button
							size="lg"
							fullWidth
							onClick={handleOpenSummary}
							variant="outline"
						>
							<Flex gap="sm">
								Podsumowanie
								<IconArrowNarrowRight />
							</Flex>
						</Button>
						{options.isPresetMode && (
							<Button color="cream.6" type="submit">
								Zapisz preset
							</Button>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};
